import React from 'react';
import { useQuery } from '@tanstack/react-query';

import { Space, Collapse, Descriptions, Spin, Divider, List } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { colors } from '@yuhuinc/ui-library';
import { apiGet } from 'helpers/ApiHelper';
import Auth from 'j-toker';

const { Panel } = Collapse;

const PanelHeader = ({ icon, title }) => {
  return (
    <Space size={12}>
      {icon}
      {title}
    </Space>
  );
};

const fetchApplicantSubmissionResponses = async (applicationId, applicantId) => {
  const response = await apiGet(
    `${Auth.getApiUrl()}/leads/applicant_submissions?cotenant_id=${applicantId}&application_id=${applicationId}&is_landlord_app=true`
  );
  return response.applicant_submission;
};

const ApplicantResponses = ({ applicationId, applicantId }) => {
  const {
    data: responses,
    isLoading,
    isSuccess,
  } = useQuery({
    queryKey: ['applicantSubmissionResponses', applicantId],
    queryFn: () => fetchApplicantSubmissionResponses(applicationId, applicantId),
  });

  return (
    <>
      {isLoading && <Spin />}
      {isSuccess && (
        <Collapse bordered={false} ghost>
          {responses.blocks.map((block, index) => (
            <Panel
              header={
                <PanelHeader
                  icon={<ExclamationCircleFilled style={{ color: colors.colors.warning }} />}
                  title={block.title}
                />
              }
              key={index}
            >
              {block.values.map((value, index) => (
                <>
                  <Divider />
                  <Descriptions bordered size={'small'} column={1} key={`description-${index}`}>
                    {block.fields.map((field, index) => (
                      <Descriptions.Item
                        contentStyle={{ width: '50%' }}
                        key={`description-item-${index}`}
                        label={field.name === 'documents' ? 'Documents' : field.label}
                      >
                        {field.name === 'documents' ? (
                          <List
                            size="small"
                            dataSource={value[field.name]}
                            renderItem={(document) => (
                              <List.Item>
                                <a href={document.url} target="_blank" rel="noreferrer">
                                  {document.name}
                                </a>
                              </List.Item>
                            )}
                          />
                        ) : (
                          value[field.name]
                        )}
                      </Descriptions.Item>
                    ))}
                  </Descriptions>
                </>
              ))}
            </Panel>
          ))}
        </Collapse>
      )}
    </>
  );
};

export default ApplicantResponses;
